module.exports = "/_next/static/media/Video2.cd41bbbf54a4781a2e1a06d8ab5f137d.mp4";